<a (click)="openShare()">
	<span class="link-container" [loading]="loading()">
		<ng-content></ng-content>
	</span>
</a>
<a #action (click)="shareClick()" [attr.href]="shareUrl()" class="hidden"></a>
<dialog #modal id="my_modal_1" class="modal">
  <div class="modal-box">
    <div class="mb-4">
    	Partager vos cartes
    </div>
    <div>
    	<img class="mb-2" src="img/skin/share.svg"/>
		<p class="text-xs mb-1">
			<b>Partagez facilement votre binder grâce à un lien unique.</b>
		</p>
		<p class="text-xs mb-4">
			Le destinataire peut le consulter, et vous gardez le contrôle en coupant le partage à tout moment.
		</p>
		<div class="check-container text-xs">
			<input type="checkbox" [ngModel]="!settings.options().messageShare" (ngModelChange)="settings.toggle('messageShare')" name="showCode" class="mr-2 toggle border-white-600 bg-white-500 checked:border-indigo-500 checked:bg-indigo-400 checked:text-indigo-800" />
			Ne plus afficher ce message.
		</div>
    </div>
    <div class="modal-action">
      <form method="dialog">
        <!-- if there is a button in form, it will close the modal -->
        <button class="btn">Retour</button>
				<a (click)="makeShare()" class="btn btn-primary btn-gradient">
		   			<!-- <i class="fa-light fa-paper-plane"></i> -->
		   			Partager
				</a>
      </form>
    </div>
  </div>
</dialog>